import { render, staticRenderFns } from "./CoursePackageComponent.vue?vue&type=template&id=cbe4296e&scoped=true"
import script from "./CoursePackageComponent.vue?vue&type=script&lang=js"
export * from "./CoursePackageComponent.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageComponent.vue?vue&type=style&index=0&id=cbe4296e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe4296e",
  null
  
)

export default component.exports